import { Route } from "@/common/Layout/Sidebar/routes";
import { ReceiptIcon, SquareXIcon, WandSparklesIcon } from "lucide-react";

export const mobileRoutes: (Omit<Route, 'path'> & { path: string })[] = [
  {
    label: 'Consumo',
    Icon: <ReceiptIcon strokeWidth={1} size={36} />,
    path: '/consumption',
    permission: 'Establishment::Client::Consumptions::Create',
  },
  {
    label: 'Consulta',
    Icon: <WandSparklesIcon strokeWidth={1} size={36} />,
    path: '/card-current-limit',
    permission: 'Establishment::Client::Cards::CurrentLimits',
  },
  {
    label: 'Estorno',
    Icon: <SquareXIcon strokeWidth={1} size={36} />,
    path: '/refund',
    permission: 'Establishment::Billing::Refunds::Create',
  },
];
